<div
  [class.visible]="isLoading || showAlways"
  class="usb-popup-overlay"
  [ngClass]="popupClass"
>
  <div
    class="d-flex align-items-center justify-content-between bg-white usb-popup-container"
  >
    <div>
      <img [src]="iconUrl ? iconUrl : '../../../assets/img/image.png'" style="height: 230px" alt="">
    </div>

    <div class="d-flex align-items-center flex-column" style="width: 100%" >
      <div class="d-flex flex-column align-items-center">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
